module.exports = __webpack_public_path__ + "static/media/contact-wx2.fee2b1bc.jpg";